import { useRouteError } from 'react-router-dom';
import { FormatCatchErrorMsg } from '@/lib/utils';

const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);
  return (
    <div className='flex h-full flex-col items-center justify-center'>
      {FormatCatchErrorMsg(error)}
    </div>
  );
};

export default ErrorBoundary;
